import { PortalPage } from '@repo/ccc-main-app-lib/src/pages/PortalPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/portal')({
  component: PortalPage,
})
